import { lazy } from 'react'
import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/apiClient'

type InstallStatusResponse = {
  installed: boolean
}

const installFrontendBuildEnabled =
  import.meta.env.VITE_ENABLE_INSTALL_FRONTEND !== 'false'
const installPageModules = import.meta.glob('./install/InstallPage.tsx')
const installPageLoader = installFrontendBuildEnabled
  ? installPageModules['./install/InstallPage.tsx']
  : undefined

export const installFrontendEnabled = Boolean(installPageLoader)

export const installStatusKeys = {
  all: ['install-status'] as const,
}

export const OptionalInstallPage = installPageLoader
  ? lazy(installPageLoader as () => Promise<{ default: React.ComponentType }>)
  : null

async function getInstallStatus(): Promise<InstallStatusResponse> {
  const response = await apiClient.get<{
    code: number
    data: InstallStatusResponse
    message: string
  }>('/public/install/status', {
    skipAuthHeader: true,
    skipAuthRefresh: true,
  })

  return response.data
}

export function useOptionalInstallStatus() {
  return useQuery({
    queryKey: installStatusKeys.all,
    queryFn: getInstallStatus,
    staleTime: 30 * 1000,
    retry: false,
    enabled: installFrontendEnabled,
  })
}
